import {
  PaymentSchemesMaster,
  PaymentSchemesMasterRequestParams
} from '../../types/paymentSchemesMasterType';
import envVar from '../../config/envVars';
import httpGet from '../httpClient/httpGet';

const fetchPaymentSchemesMaster = async (
  params: PaymentSchemesMasterRequestParams
): Promise<PaymentSchemesMaster> => {
  const response = await httpGet(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/schools/${params.school}/payment-schemes/${params.academicYear}/${params.grade}`,
    {
      headers: {
        Authorization: `Bearer ${envVar.REACT_APP_PAYMENTS_API_TOKEN}`
      }
    }
  );
  return response as unknown as PaymentSchemesMaster;
};

const paymentSchemesMaster = {
  fetchPaymentSchemesMaster
};

export default paymentSchemesMaster;
